var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "查看骑手信息",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        "custom-class": "dialog",
        "before-close": _vm.handleCancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "container",
        },
        [
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("手机号码")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.riderDetail?.cPhone)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("姓名")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.riderDetail?.cName)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("性别")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.sexMap[_vm.riderDetail?.bSex ?? 0])),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("已加盟的平台")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.riderDetail?.sPlatform)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("所在区域")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(
                _vm._s(
                  _vm.findLabelsByIds(
                    _vm.baseArea,
                    _vm.riderDetail?.cRegion ?? []
                  )
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("常住地址")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.riderDetail?.cAddress)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("工作时间")]),
            _c("div", { staticClass: "content" }, [_vm._v("全天")]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("启用状态")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.statusMap[_vm.riderDetail?.bStatus ?? 1])),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("登记时间")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.dateFormatter(_vm.riderDetail?.tCreate))),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title" }, [_vm._v("骑手来源")]),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.riderDetail.sStore)),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }